import { render, staticRenderFns } from "./dialog-movefile.vue?vue&type=template&id=008f259c&"
import script from "./dialog-movefile.vue?vue&type=script&lang=js&"
export * from "./dialog-movefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports